import {Component, OnInit, ViewChild, signal} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddMasterProductComponent } from './add-master-product/add-master-product.component';
import { DeleteMasterProductComponent } from './delete-master-product/delete-master-product.component';
import { MasterdataService } from '../../services/masterdata.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BASE_URL } from '../../../config/config';
import { PaginationComponent } from '../../common/pagination/pagination.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessagePopupComponent } from '../../bulk-upload/modals/message-popup/message-popup.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-master-categories',
  standalone: true,
  imports: [CommonModule,FormsModule,PaginationComponent],
  templateUrl: './master-categories.component.html',
  styleUrls: ['./master-categories.component.scss', '../../../app.component.scss']
})

export class MasterCategoriesComponent {
  @ViewChild(PaginationComponent) paginationView: PaginationComponent;
  totalcategoryCount: number = 0; 
  public alerts: any = []
  public delete: any = [] 
  public masterType = "product_categories";
  public fileType = ""; 
  public isFile = false;
  public uploadedFile: any;
  public statusType: string = "";
  public statusMessage: string = "";
  searchTerm: string = ''; 
  public category: any = [] 
  public isDragOver = signal(false);
  public implants: any ;
  public paginationData: any;
  public totalPages: number = 0;
  public currentPage: number = 1;
  nameImplantTxt: any;
  public name: any;
  public search : any = [];

  public searchInput: string = "";
  public encodedSearchInput: string = "";

  public isSearch = false;
  public isFilter = false;
  public isFilterResult = true;

  public selectedStatus = [];

  public BASE = BASE_URL.URL;

  constructor(private spinnerService: NgxSpinnerService,public dialog: MatDialog, public masterdataService: MasterdataService,public router: Router) { }

  ngOnInit(): void {
    this.getMasterImplants()
    this.getMasterProductCategory(this.search,this.currentPage)
  }

  dropFile(e) {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.fileValidation(file)
    }
    
    this.isDragOver.set(false);
  }

  dragOverFile(e) {
    e.preventDefault();
    this.isDragOver.set(true);
  }

  dragLeaveFile(e) {
    e.preventDefault();
    this.isDragOver.set(false);
  }

  browseFile(e){
    e.preventDefault();
    let fileInput: any = document.getElementById("mastercategorieswrapper").querySelector('[id="file-input"]');
    if (fileInput) fileInput.click();
  }
  
  dragEndFile(e) {
    e.preventDefault();
    this.isDragOver.set(false);
  }

  onFileChange(event){
    event.preventDefault();
    const file = event.target.files[0];
    if (file) {
      this.fileValidation(file);
    }
  }

  fileValidation(file){
    const validFileTypes = ['csv', 'xlsx', 'xls'];
    let ext = file.name.substring(file.name.lastIndexOf('.') + 1);
    if (validFileTypes.includes(ext)) {
      this.isFile = true;
      this.fileType = ext;
      this.uploadedFile = file;
    }else{
      this.statusType = 'error';
      this.statusMessage = `File format is invalid. Only Excel and CSV formats are allowed.`;
      this.showWarningToast();
    }
  }

  onSubmit() {
    this.spinnerService.show(); 
    let formData = new FormData();
    
    formData.append('file', this.uploadedFile);
    let loggedUser = JSON.parse(localStorage.getItem('role'));
    // formData.append('warehouse_id', loggedUser.resource_id);

    let token = localStorage.getItem('token');

    fetch(`${this.BASE}/bulk-stocks/master/upload/${this.masterType}`, {
      method: 'POST',
      body: formData,
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }).then((response)=>{
      if (response.status === 200) {
        if (response.headers.get('Content-Type') === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
          const uploadeEntries = response.headers.get('Uploaded-Entries');
          const invalidEntries = response.headers.get('Invalid-Entries');
          let fileName = `${this.masterType}-${this.fileType}-error`;
          return response.blob().then((blobContent) => {
            this.getMasterProductCategory(this.search,this.currentPage);
            this.openDialogBrowse(blobContent, uploadeEntries, invalidEntries, fileName);
          })
        }else if(response.headers.get('Content-Type') === "application/json"){
          this.statusType = 'success';
          this.statusMessage = `The ${this.uploadedFile.name} data has been uploaded successfully!`;
          this.showWarningToast();
          this.getMasterProductCategory(this.search,this.currentPage);
        }
      }

      if (response.status === 204) {
        this.statusType = 'success';
        this.statusMessage = 'Nothing to update';
        this.showWarningToast();
      }

      if (response.status === 422) {
        this.statusType = 'error';
        this.statusMessage = 'Unprocessable Content';
        this.showWarningToast();
        
        response.json().then((jsonData) =>{
          if (!jsonData.data.excluded) {
            this.statusType = 'error';
            this.statusMessage = 'Error: The uploaded file and uploaded for doesn’t match';
            this.showWarningToast();
          }
        })
      }

      if (response.status === 401) {
        localStorage.clear();
        this.router.navigateByUrl('/login');
        this.spinnerService.hide();
        return;
      }

      if (response.status === 500) {
        this.statusType = 'error';
        this.statusMessage = `Oops, Something went wrong!`;
        this.showWarningToast();
      }
    })
    .catch((err)=>{
      this.spinnerService.hide();
      console.log('err', err);
    }).finally(()=>{
      this.spinnerService.hide();
    })
  }

  openDialogBrowse(blob, uploadeEntries: string, invalidEntries: string, fileName: string): void {
    const dialogRef = this.dialog.open(MessagePopupComponent, {
      data: {
        blob,
        uploadeEntries, 
        invalidEntries,
        fileName
      }
    });

    dialogRef.afterClosed().subscribe(result => {});
  }

  resetFile(){
    this.isFile = false;
    this.fileType = '';
  }

  showWarningToast(){
    const toastContainer = document.getElementById('warning-toast');

    if (toastContainer) {
      setTimeout(function() {
        toastContainer.classList.add('show');
      }, 100);
      setTimeout(function() {
        toastContainer.classList.remove('show');
      }, 5000);
    }
  }

  downloadBulkUploadTemplate(product_categories) {
    this.masterdataService.downloadBulkUploadTemplate(product_categories);
  }

  openEditDialog(category:any): void {
    console.log("openeditbody", category)
    const dialogRef = this.dialog.open(AddMasterProductComponent, {
      disableClose: true,
      data: {
        type: "edit",
        item: category,
        implants: this.implants,
      }
    }).afterClosed().subscribe(()=>{
      this.getMasterImplants();
      this.getMasterProductCategory(this.search,this.currentPage);
    });
  }

  openDialog(category): void {
    this.getMasterImplants(); 
    const dialogRef = this.dialog.open(AddMasterProductComponent, {
      data:{
        type: "add",
        implants: this.implants
      }
    });
    dialogRef.afterClosed().subscribe(()=>{
      this.getMasterImplants();
      this.getMasterProductCategory(this.search,this.currentPage);
    });
  }

  openDeleteDialog(item: any): void {
    const dialogRef = this.dialog.open(DeleteMasterProductComponent, {
    }).afterClosed().subscribe(result=>{
      if(result == "confirm"){
        this.masterdataService.deleteBodyParts(item.id, "product_categories").subscribe((res:any)=>{
          if(res && res.success){
            this.getMasterImplants();
            this.getMasterProductCategory(this.search,this.currentPage);
          }
        })
      }
    });
  }

  getMasterImplants(){
    this.masterdataService.getMasterImplants(this.search,this.currentPage).subscribe((res)=>{
      if (res.data && res.data.data) {
        this.implants = res.data.data.map(item => {return {id:item.id, value:item.name}});
      }
    });
  }
 
  getMasterProductCategory(search: string = "", currentPage: number){
    this.masterdataService.getMasterProductCategory(search, currentPage).subscribe((res)=>{
      if (res.data) {
        this.category = res.data.data;
        this.paginationData = res.data.data;
        this.totalcategoryCount =  res.data.total;
        this.paginationData.totalPage = Math.ceil(res.data.total / 15);
        console.log(this.paginationData, " paginationData");
      }
    });
  }

  onSearchSubmit(){
    if (this.searchInput !== "") {
      this.isSearch = true;
      if (this.isFilter) { 
        this.isFilter = false;
        this.isFilterResult = true;
      }
      this.encodedSearchInput = encodeURIComponent(this.searchInput);
      this.getMasterProductCategory(this.encodedSearchInput, this.currentPage);
    }
  }

  getQueryPage(event:any){
    console.log(event);
    this.currentPage = event;
    this.getMasterProductCategory(this.search,this.currentPage)
  }

  searchByCategoryName(): void {
    this.category = this.category.filter((category: any) =>
      category.name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  reset(event: Event){
    event.preventDefault();
    if (this.isSearch || this.isFilter) {
      this.encodedSearchInput = "";
      this.selectedStatus = [];
      this.isSearch = false;
      this.isFilter = false;
      this.isFilterResult = true;
      this.getMasterProductCategory(this.encodedSearchInput, this.currentPage);
    }
  }


}
